import CardSystem from '../CardSystem';
import { ICardStateTaskData } from '../../../State/Card/ICardState';

export default function FogEndCardAnimation(
    system: CardSystem,
    taskData: ICardStateTaskData
): void {}
